import React, { useEffect, useState, useMemo, useCallback, useRef } from "react";
import _ from "lodash";
import { useSelector } from "react-redux";
// @material-ui/core components
import {
  Box,
  Dialog,
  Fab,
  IconButton,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
// core components
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import CustomInput from "../../components/CustomInput/CustomInput.js";
import Button from "../../components/CustomButtons/Button.js";
import Card from "../../components/Card/Card.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import axios from "axios";
import {
  GetAllAccountsWithLightweightAPI,
  GetAllFittingMastersAPI,
  GetAllOrdersAPI,
  GetAllReadyMastersCodesAPI,
  CreateBulkOrderAPI,
} from "../../config/api";
import DateUtils from "@date-io/moment";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { createFilterOptions } from "@material-ui/lab/Autocomplete";
import { toast } from "react-toastify";
import { FilePicker } from "../../components/common/FilePicker.js";
import { ChallanOrdersDialog } from "../Challan/ChallanOrdersDialog.js";

const filterOptions = createFilterOptions({
  matchFrom: "any",
  limit: 500,
});

const styles = {
  formControl: {
    paddingBottom: "10px",
    margin: "27px 0 0 0",
    position: "relative",
    verticalAlign: "unset",
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    flex: 1,
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
};

const useStyles = makeStyles(styles);

const columns = [
  { id: "party", label: "Party" },
  { id: "productNameR", label: "Product R" },
  { id: "productNameL", label: "Product L" },
  { id: "rSph", label: "Right Sph" },
  { id: "rCyl", label: "Right Cyl" },
  { id: "rAxis", label: "Right Axis" },
  { id: "rAddition", label: "Right Add" },
  { id: "lSph", label: "Left Sph" },
  { id: "lCyl", label: "Left Cyl" },
  { id: "lAxis", label: "Left Axis" },
  { id: "lAddition", label: "Left Add" },
  { id: "action", label: "Action" },
];

export default function FittingOrderAdd(props) {
  const classes = useStyles();
  const theme = useTheme();
  let userInfo = useSelector((state) => state.userReducer.userInfo);
  let authToken = useSelector((state) => state.userReducer.authToken);

  const readyMastersProducts = useSelector(
    (state) => state.userReducer.readyMasters
  );

  const { open, close, fetchData } = props;

  const [rLens, setRLens] = useState("");
  const [lLens, setLLens] = useState("");
  const [fitter, setFitter] = useState("");
  const [fitting, setFitting] = useState("");
  const [given, setGiven] = useState(new Date());
  const [received, setReceived] = useState(new Date());
  const [cg, setCg] = useState("");
  const [amount, setAmount] = useState(0);
  const [quantity, setQuantity] = useState("");
  const [partyRef, setPartyRef] = useState("");
  const [rRate, setRRate] = useState("");
  const [lRate, setLRate] = useState("");
  const [productNameR, setProductNameR] = useState("");
  const [productNameL, setProductNameL] = useState("");
  const [product, setProduct] = useState("");
  const [quote, setQuote] = useState("");
  const [dia, setDia] = useState("");
  const [rSph, setRSph] = useState("");
  const [rCyl, setRCyl] = useState("");
  const [rAxis, setRAxis] = useState("");
  const [rAddition, setRAddition] = useState("");
  const [lSph, setLSph] = useState("");
  const [lCyl, setLCyl] = useState("");
  const [lAxis, setLAxis] = useState("");
  const [lAddition, setLAddition] = useState("");
  const [party, setParty] = useState(null);
  const [orderNotes, setOrderNotes] = useState("");

  const [accounts, setAccounts] = useState([]);
  const [fittings, setFittings] = useState([]);
  const [readyMasters, setReadyMasters] = useState([]);
  const [orders, setOrders] = useState([]);
  const [openOrdersDialog, setOpenOrdersDialog] = useState(false);
  const [codes, setCodes] = useState([]);
  const [codesL, setCodesL] = useState([]);
  const [codesR, setCodesR] = useState([]);
  const [items, setItems] = useState([]);
  const savingOrdersRef = useRef(false);
  const [isSavingOrders, setIsSavingOrders] = useState(false);
  const [categoryImage, setCategoryImage] = useState([]);

  // Loading states
  const [loadingCodesR, setLoadingCodesR] = useState(false);
  const [loadingCodesL, setLoadingCodesL] = useState(false);

  // Refs for request cancellation
  const codesRAbortControllerRef = useRef(null);
  const codesLAbortControllerRef = useRef(null);

  // Cache for codes API results
  const codesCacheRef = useRef(new Map());
  const CACHE_TTL = 15 * 60 * 1000; // 15 minutes

  // Refs to access current state values in closures
  const codeRRef = useRef(rLens);
  const codeLRef = useRef(lLens);

  // Refs to store debounced functions for cleanup
  const debouncedEffectRef = useRef(null);
  const debouncedEffectLRef = useRef(null);

  // Helper function to get cache key
  const getCodesCacheKey = useCallback((entity, productCode, side) => {
    return `${entity}_${productCode}_${side}`;
  }, []);

  // Helper function to check cache with smart prefix matching
  const getCachedCodes = useCallback((entity, productCode, side) => {
    // Try exact match first
    const exactKey = getCodesCacheKey(entity, productCode, side);
    const exactCached = codesCacheRef.current.get(exactKey);
    if (exactCached && Date.now() - exactCached.timestamp < CACHE_TTL) {
      return exactCached.data;
    }

    // Try prefix matches (check if longer search is subset of cached shorter search)
    // Check prefixes from longest to shortest
    for (let i = productCode.length - 1; i >= 3; i--) {
      const prefix = productCode.substring(0, i);
      const prefixKey = getCodesCacheKey(entity, prefix, side);
      const prefixCached = codesCacheRef.current.get(prefixKey);
      if (prefixCached && Date.now() - prefixCached.timestamp < CACHE_TTL) {
        // Filter cached results to match current search
        const filtered = prefixCached.data.filter(code =>
          code.productCode && code.productCode.toLowerCase().startsWith(productCode.toLowerCase())
        );
        if (filtered.length > 0) {
          return filtered;
        }
      }
    }

    return null;
  }, [getCodesCacheKey]);

  // Helper function to set cache
  const setCachedCodes = useCallback((entity, productCode, side, data) => {
    const key = getCodesCacheKey(entity, productCode, side);
    codesCacheRef.current.set(key, {
      data,
      timestamp: Date.now()
    });
  }, [getCodesCacheKey]);

  // Update refs when state changes
  useEffect(() => {
    codeRRef.current = rLens;
  }, [rLens]);

  useEffect(() => {
    codeLRef.current = lLens;
  }, [lLens]);

  // Memoized codes from orders
  const orderCodes = useMemo(() => {
    return orders.map((i) => i.code).filter(Boolean);
  }, [orders]);

  // Debounced effect for R lens
  const debouncedEffect = useMemo(
    () => {
      const debounced = _.debounce((codeR) => {
        let obj;
        let codes = [...orderCodes];
        let codesR = [...orderCodes];
        if (codeR) {
          obj = orders.find((o) => o.code === codeR);
          if (!obj) {
            if (codeR?.length < 5) {
              return;
            }

            // Check cache first
            const cachedData = getCachedCodes(userInfo.entity, codeR, "R");
            if (cachedData) {
              setReadyMasters(cachedData);
              const readyMasterCodes = cachedData.map((i) => i.productCode);
              const readyMasterCodesR = cachedData
                .filter((i) => i.side === "B" || i.side === "R")
                .map((i) => i.productCode);

              codes = [...orderCodes, ...readyMasterCodes];
              codesR = [...orderCodes, ...readyMasterCodesR];

              // Reorder codesR array - move codes starting with 'o' to the end
              codesR.sort((a, b) => {
                if (a.startsWith("o") && !b.startsWith("o")) {
                  return 1;
                } else if (!a.startsWith("o") && b.startsWith("o")) {
                  return -1;
                }
                return 0;
              });
              setCodesR(codesR);
              setCodes(codes);
              return;
            }

            // Cancel previous request
            if (codesRAbortControllerRef.current) {
              codesRAbortControllerRef.current.abort();
            }
            codesRAbortControllerRef.current = new AbortController();

            setLoadingCodesR(true);
            axios
              .get(GetAllReadyMastersCodesAPI(userInfo.entity, codeR, "R"), {
                headers: {
                  Authorization: `Bearer ${authToken}`,
                },
                signal: codesRAbortControllerRef.current.signal,
              })
              .then((res) => {
                const readyMastersData = res.data.readyMasters || [];
                // Limit results to 200 on frontend as well
                const limitedReadyMasters = readyMastersData.slice(0, 200);

                // Cache the results
                setCachedCodes(userInfo.entity, codeR, "R", limitedReadyMasters);

                setReadyMasters(limitedReadyMasters);
                const readyMasterCodes = limitedReadyMasters.map((i) => i.productCode);
                const readyMasterCodesR = limitedReadyMasters
                  .filter((i) => i.side === "B" || i.side === "R")
                  .map((i) => i.productCode);

                codes = [...orderCodes, ...readyMasterCodes];
                codesR = [...orderCodes, ...readyMasterCodesR];

                // Reorder codesR array - move codes starting with 'o' to the end
                codesR.sort((a, b) => {
                  if (a.startsWith("o") && !b.startsWith("o")) {
                    return 1;
                  } else if (!a.startsWith("o") && b.startsWith("o")) {
                    return -1;
                  }
                  return 0;
                });
                setCodesR(codesR);
                setCodes(codes);
              })
              .catch((e) => {
                if (e.name !== 'AbortError' && e.code !== 'ECONNABORTED') {
                  // Request was cancelled, ignore error
                }
              })
              .finally(() => {
                setLoadingCodesR(false);
              });
          }
        }
        setCodes(codes);
      }, 500);
      debouncedEffectRef.current = debounced;
      return debounced;
    },
    [orders, orderCodes, fittings, userInfo.entity, authToken, getCachedCodes, setCachedCodes]
  );

  // Debounced effect for L lens
  const debouncedEffectL = useMemo(
    () => {
      const debounced = _.debounce((codeL) => {
        let obj;
        let codes = [...orderCodes];
        let codesL = [...orderCodes];
        if (codeL) {
          obj = orders.find((o) => o.code === codeL);
          if (!obj) {
            if (codeL?.length < 5) {
              return;
            }

            // Check cache first
            const cachedData = getCachedCodes(userInfo.entity, codeL, "L");
            if (cachedData) {
              setReadyMasters(cachedData);
              const readyMasterCodes = cachedData.map((i) => i.productCode);
              const readyMasterCodesL = cachedData
                .filter((i) => i.side === "B" || i.side === "L")
                .map((i) => i.productCode);

              codes = [...orderCodes, ...readyMasterCodes];
              codesL = [...orderCodes, ...readyMasterCodesL];

              // Reorder codesL array - move codes starting with 'o' to the end
              codesL.sort((a, b) => {
                if (a.startsWith("o") && !b.startsWith("o")) {
                  return 1;
                } else if (!a.startsWith("o") && b.startsWith("o")) {
                  return -1;
                }
                return 0;
              });
              setCodesL(codesL);
              setCodes(codes);
              return;
            }

            // Cancel previous request
            if (codesLAbortControllerRef.current) {
              codesLAbortControllerRef.current.abort();
            }
            codesLAbortControllerRef.current = new AbortController();

            setLoadingCodesL(true);
            axios
              .get(GetAllReadyMastersCodesAPI(userInfo.entity, codeL, "L"), {
                headers: {
                  Authorization: `Bearer ${authToken}`,
                },
                signal: codesLAbortControllerRef.current.signal,
              })
              .then((res) => {
                const readyMastersData = res.data.readyMasters || [];
                // Limit results to 200 on frontend as well
                const limitedReadyMasters = readyMastersData.slice(0, 200);

                // Cache the results
                setCachedCodes(userInfo.entity, codeL, "L", limitedReadyMasters);

                setReadyMasters(limitedReadyMasters);
                const readyMasterCodes = limitedReadyMasters.map((i) => i.productCode);
                const readyMasterCodesL = limitedReadyMasters
                  .filter((i) => i.side === "B" || i.side === "L")
                  .map((i) => i.productCode);

                codes = [...orderCodes, ...readyMasterCodes];
                codesL = [...orderCodes, ...readyMasterCodesL];

                // Reorder codesL array - move codes starting with 'o' to the end
                codesL.sort((a, b) => {
                  if (a.startsWith("o") && !b.startsWith("o")) {
                    return 1;
                  } else if (!a.startsWith("o") && b.startsWith("o")) {
                    return -1;
                  }
                  return 0;
                });
                setCodesL(codesL);
                setCodes(codes);
              })
              .catch((e) => {
                if (e.name !== 'AbortError' && e.code !== 'ECONNABORTED') {
                  // Request was cancelled, ignore error
                }
              })
              .finally(() => {
                setLoadingCodesL(false);
              });
          }
        }
        setCodes(codes);
      }, 500);
      debouncedEffectLRef.current = debounced;
      return debounced;
    },
    [orders, orderCodes, fittings, userInfo.entity, authToken, getCachedCodes, setCachedCodes]
  );

  const _getUsers = useCallback(async () => {
    console.log("get users");
    if (!userInfo?.entity || !authToken) return;
    try {
      console.log("get users try");
      const res = await axios.get(GetAllAccountsWithLightweightAPI(userInfo.entity, 'sale'), {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      console.log("get users res", res);
      if (res.data && Array.isArray(res.data.accounts)) {
        setAccounts(res.data.accounts);
      } else {
        setAccounts([]);
      }
    } catch (e) {
      console.error("Error fetching users:", e);
      setAccounts([]);
    }
  }, [userInfo?.entity, authToken]);

  const _getFittings = useCallback(async () => {
    try {
      let res = await axios.get(GetAllFittingMastersAPI(userInfo.entity), {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      setFittings(res.data.fittingMasters);
    } catch (e) {
      // console.log("er:", e);
      // toast.error(("Something went wrong, Please Contact Admin") , {
      //   position: "top-center",
      //   autoClose: 1500,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "light",
      //   });
    }
  }, [userInfo?.entity, authToken]);

  useEffect(() => {
    // Only fetch data when modal is open
    if (open && userInfo?.entity) {
      _getUsers();
      console.log("get users after");
      _getFittings();
      // Removed _getReady() - will use debounced API calls instead
    }

    // Cleanup on unmount
    return () => {
      if (codesRAbortControllerRef.current) {
        codesRAbortControllerRef.current.abort();
      }
      if (codesLAbortControllerRef.current) {
        codesLAbortControllerRef.current.abort();
      }
      // Cleanup debounced functions using refs
      if (debouncedEffectRef.current) {
        debouncedEffectRef.current.cancel();
      }
      if (debouncedEffectLRef.current) {
        debouncedEffectLRef.current.cancel();
      }
    };
  }, [open, _getUsers, _getFittings, userInfo?.entity]);

  useEffect(() => {
    _getOrders();
    console.log("get orders after");
  }, [party]);

  // Removed _getReady() - using debounced GetAllReadyMastersCodesAPI instead

  // Fill form from selected order (used by View Orders modal)
  const setFormFromOrder = useCallback((row) => {
    const d = row?.orderDetail || {};
    if (row?.code) {
      setRLens(row.code);
      setLLens(row.code);
    }
    if (d.rSph !== undefined && d.rSph !== null && d.rSph !== "") setRSph(String(d.rSph));
    if (d.rCyl !== undefined && d.rCyl !== null && d.rCyl !== "") setRCyl(String(d.rCyl));
    if (d.rAxis !== undefined && d.rAxis !== null && d.rAxis !== "") setRAxis(String(d.rAxis));
    if (d.rAddition !== undefined && d.rAddition !== null && d.rAddition !== "") setRAddition(String(d.rAddition));
    if (d.lSph !== undefined && d.lSph !== null && d.lSph !== "") setLSph(String(d.lSph));
    if (d.lCyl !== undefined && d.lCyl !== null && d.lCyl !== "") setLCyl(String(d.lCyl));
    if (d.lAxis !== undefined && d.lAxis !== null && d.lAxis !== "") setLAxis(String(d.lAxis));
    if (d.lAddition !== undefined && d.lAddition !== null && d.lAddition !== "") setLAddition(String(d.lAddition));
    if (d.rRate !== undefined && d.rRate !== null && d.rRate !== "") setRRate(String(d.rRate));
    if (d.lRate !== undefined && d.lRate !== null && d.lRate !== "") setLRate(String(d.lRate));
    if (d.productNameR !== undefined && d.productNameR != null) setProductNameR(d.productNameR);
    if (d.productNameL !== undefined && d.productNameL != null) setProductNameL(d.productNameL);
    if (d.product?.productName) setProductNameR((prev) => prev || d.product.productName);
    if (d.amount !== undefined && d.amount !== null && d.amount !== "") setAmount(String(d.amount));
    if (d.quantity !== undefined && d.quantity !== null && d.quantity !== "") setQuantity(String(d.quantity));
  }, []);

  async function _getOrders() {
    try {
      if (party) {
        let res = await axios.get(
          GetAllOrdersAPI(userInfo.entity) +
          `&userId=${party._id}&orderType=Prescription`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        setOrders(res.data.orders);
      }
    } catch (err) {
      // console.log("error:", err);
      // toast.error(("Something went wrong, Please Contact Admin") , {
      //   position: "top-center",
      //   autoClose: 1500,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "light",
      //   });
    }
  }

  async function _onSave() {
    if (savingOrdersRef.current) return;
    try {
      let ordersToSave = [...items];
      let wasAutoAdded = false;

      // If no items in list, check if current form has data and add it
      if (ordersToSave.length === 0) {
        wasAutoAdded = true;
        // Validate required fields
        if (party === null || quantity === "" || amount === "") {
          toast.error("Please fill all the required fields", {
            position: "top-center",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          return;
        }

        // Auto-add current form data to orders
        let orderAmount = Number(amount) * Number(quantity);
        const imagePath = categoryImage.length ? categoryImage[0].path : "";
        let object = {
          orderType: "Fitting",
          orderNotes: orderNotes,
          party: {
            accountCode: party.accountCode,
            accountId: party._id,
            accountName: party.name,
            accountAddress: party.address,
            accountGst: party.gst,
            balanceLock: party.balanceLock,
            runningChallanBalance: party.runningChallanBalance,
            runningBillBalance: party.runningBillBalance,
          },
          orderDetail: {
            rLens,
            lLens,
            fitter,
            fitting: fitting ? fitting.fittingType : "",
            cg,
            given,
            received,
            amount,
            quantity,
            partyRef,
            rRate,
            lRate,
            product,
            productNameR,
            productNameL,
            quote,
            dia,
            rSph,
            rCyl,
            rAxis,
            rAddition,
            lSph,
            lCyl,
            lAxis,
            lAddition,
            orderNotes,
          },
          orderAmount,
          price: amount,
          quantity,
          createdBy: userInfo._id,
          createdByName: userInfo.name,
          orderAdminStatus: "Pending",
          image: imagePath,
        };
        ordersToSave.push(object);
      }

      // Balance Lock check (admin-defined)
      for (const o of ordersToSave) {
        const p = o?.party;
        const lock = Number(p?.balanceLock || 0);
        if (lock > 0) {
          const current = Number(p?.runningChallanBalance ?? p?.runningBillBalance ?? 0);
          const projected = current + Number(o?.orderAmount || 0);
          if (projected > lock) {
            toast.error(
              `Balance locked for ${p?.accountName || "this account"}. Limit: ${lock}, Projected: ${Math.round(projected)}`,
              { position: "top-center", autoClose: 3000, theme: "light" }
            );
            return;
          }
        }
      }

      savingOrdersRef.current = true;
      setIsSavingOrders(true);

      const formData = new FormData();
      formData.append("entity", userInfo.entity);

      ordersToSave.forEach((item, index) => {
        const orderData = {
          orderType: item.orderType,
          createdBy: item.createdBy,
          createdByName: item.createdByName,
          orderDetail: item.orderDetail,
          orderAmount: item.orderAmount,
          orderAdminStatus: item.orderAdminStatus,
          quantity: item.quantity,
          price: item.price,
          party: item.party,
          orderNotes: item.orderNotes,
          imageName: item.image ? item.image.name : "noimg",
        };

        formData.append(`orders[${index}]`, JSON.stringify(orderData));
        formData.append("check", true);

        if (item.image) {
          formData.append(`image`, item.image);
        }
      });

      let res = await axios.post(CreateBulkOrderAPI(), formData, {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "multipart/form-data",
        },
      });
      setItems([]);
      setCategoryImage([]);

      // Clear form fields if we auto-added the current form data
      if (wasAutoAdded) {
        setLRate("");
        setDia("");
        setLSph("");
        setLCyl("");
        setLAxis("");
        setLAddition("");
        setProductNameR("");
        setProductNameL("");
        setProduct("");
        setRRate("");
        setRSph("");
        setRCyl("");
        setRAxis("");
        setRAddition("");
        setRLens("");
        setLLens("");
        setFitter("");
        setFitting("");
        setGiven(new Date());
        setReceived(new Date());
        setCg("");
        setAmount("");
        setQuantity("");
        setPartyRef("");
        setQuote("");
        setOrderNotes("");
      }

      toast.success("Successfully Added!", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      close();
      fetchData();
    } catch (e) {
      // console.log("err:", e);
      // toast.error(("Something went wrong, Please Contact Admin") , {
      //   position: "top-center",
      //   autoClose: 1500,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "light",
      //   });
    } finally {
      savingOrdersRef.current = false;
      setIsSavingOrders(false);
    }
  }

  useEffect(() => {
    _getCodes();
  }, [orders]);

  useEffect(() => {
    if (lLens) {
      let obj = _.find(orders, { code: lLens });
      if (obj) {
        // Handle order object
        if (obj.productName) {
          setLRate(obj.rate);
          setDia(obj.dia);
          setLSph(obj.sph);
          setLCyl(obj.cyl);
          setLAxis(obj.axis);
          setLAddition(obj.addition);
          setProductNameL(obj.productName);
          setProduct(obj);
        } else {
          if (obj.orderDetail) {
            setLRate(obj.rate);
            setDia(obj.orderDetail.dia);
            setLSph(obj.orderDetail.sphLeft);
            setLCyl(obj.orderDetail.cylLeft);
            setLAxis(obj.orderDetail.axisLeft);
            setLAddition(obj.orderDetail.addLeft);
            setProductNameL(obj.orderDetail.product.productName);
            setProduct(obj.orderDetail.product);
          }
        }
      } else {
        // Not found in orders, trigger debounced effect
        debouncedEffectL(lLens);
      }
    }
    if (!lLens) {
      if (!rLens) {
        _getCodes();
      }
      setLRate("");
      setDia("");
      setLSph("");
      setLCyl("");
      setLAxis("");
      setLAddition("");
      setProductNameR("");
      setProductNameL("");
      setProduct("");
    }
  }, [lLens, debouncedEffectL]);

  useEffect(() => {
    if (rLens) {
      let obj = _.find(orders, { code: rLens });
      if (obj) {
        // Handle order object
        if (obj.productName) {
          setRRate(obj.rate);
          setDia(obj.dia);
          setRSph(obj.sph);
          setRCyl(obj.cyl);
          setRAxis(obj.axis);
          setRAddition(obj.addition);
          setProductNameR(obj.productName);
          setProduct(obj);
        } else {
          if (obj.orderDetail) {
            setRRate(obj.rate);
            setDia(obj.orderDetail.dia);
            setRSph(obj.orderDetail.sphRight);
            setRCyl(obj.orderDetail.cylRight);
            setRAxis(obj.orderDetail.axisRight);
            setRAddition(obj.orderDetail.addRight);
            setProductNameR(obj.orderDetail.product.productName);
            setProduct(obj.orderDetail.product);
          }
        }
      } else {
        // Not found in orders, trigger debounced effect
        debouncedEffect(rLens);
      }
    }
    if (!rLens) {
      if (!lLens) {
        _getCodes();
      }
      setRRate("");
      setDia("");
      setRSph("");
      setRCyl("");
      setRAxis("");
      setRAddition("");
      setProductNameR("");
      setProductNameL("");
      setProduct("");
    }
  }, [rLens, debouncedEffect]);

  // useEffect(() => {
  //   if (fitting) {
  //     setAmount(Number(amount) + Number(fitting.amount));
  //   } else {
  //     setAmount("");
  //   }
  // }, [fitting]);

  // useEffect(() => {
  //   if (rRate && lRate) {
  //     setAmount(amount + (Number(rRate) + Number(lRate)) / 2);
  //   } else {
  //     setAmount("");
  //   }
  // }, [rRate, lRate]);

  useEffect(() => {
    let updatedAmount = 0;

    if (fitting) {
      updatedAmount += Number(fitting.amount);
    }

    if (rRate && lRate) {
      updatedAmount += (Number(rRate) + Number(lRate)) / 2;
    } else if (rRate) {
      updatedAmount += Number(rRate);
    } else if (lRate) {
      updatedAmount += Number(lRate);
    }

    setAmount(updatedAmount || 0);
  }, [fitting, rRate, lRate]);

  function _getCodes() {
    if (!lLens && !rLens) {
      // Only populate from orders when both rLens and lLens are empty
      let codes = [];
      _.map(orders, (i) => {
        codes.push(i.code);
      });
      setCodes(codes);
      setCodesL(codes);
      setCodesR(codes);
    }
  }

  // Removed debouncingProducts - replaced with debouncedEffect and debouncedEffectL

  const afterSelectL = useCallback((codeL) => {
    let obj;

    // First check if it's an order code
    if (orders && orders.length > 0) {
      obj = orders.find((o) => o.code === codeL);
    }

    // If not found in orders, check readyMasters
    if (!obj && readyMasters && readyMasters.length > 0) {
      obj = _.find(readyMasters, { productCode: codeL });
    }

    // If still not found, try to get from cache using the code prefix
    if (!obj && codeL && codeL.length >= 5) {
      // Try to find in cache by checking prefixes
      for (let i = codeL.length; i >= 5; i--) {
        const prefix = codeL.substring(0, i);
        const cachedData = getCachedCodes(userInfo.entity, prefix, "L");
        if (cachedData && cachedData.length > 0) {
          obj = cachedData.find((item) => item.productCode === codeL);
          if (obj) {
            // Update readyMasters with cached data so it's available for future use
            setReadyMasters(cachedData);
            break;
          }
        }
      }
    }

    if (obj) {
      console.log(obj, "this my product");
      if (obj.productName) {
        // Ready master product - set all fields
        setLRate(obj.rate);
        setDia(obj.dia);
        setLSph(obj.sph);
        setLCyl(obj.cyl);
        setLAxis(obj.axis);
        setLAddition(obj.addition);
        setProductNameL(obj.productName);
        setProduct(obj);

        let dissArray = party?.discounts;
        if (dissArray && dissArray.length > 0 && obj) {
          console.log(dissArray, "diss");
          console.log(obj, "dissObj");
          let selectedDis = dissArray
            .reverse()
            .find((item) => item.type === "Range");
          console.log("this happening", selectedDis);
          if (selectedDis) {
            let fR = selectedDis?.product?.codeRanges?.find(
              (item) => item == codeL
            );
            if (fR != undefined) {
              console.log("comp316");
              // setNameL(selectedDis.product.productName)
              setLRate(selectedDis.discountedPrice);
              // setDiscountPercent(selectedDis.discountPercent);
            }
          } else {
            console.log("no range here");
            let selectedDis2 = dissArray
              .reverse()
              .find(
                (item) =>
                  (!item.type || item.type === "Color") &&
                  item.product?.color &&
                  obj.color &&
                  String(item.product.color).trim().toLowerCase() ===
                  String(obj.color).trim().toLowerCase()
              );
            console.log("forReal>>>>editse", selectedDis2, codeL, dissArray);
            console.log("comp330", selectedDis2);
            if (selectedDis2) {
              // setNameL(selectedDis2?.product?.productName)
              // setDiscountPercent(selectedDis2.discountPercent)
              setLRate(selectedDis2?.discountedPrice);
              // setDiscountPercent(selectedDis2?.discountPercent);
              // setDiscountAmount(selectedDis2.discountedPrice);
              // if (discountPercent > 0) {
              //   let newD =
              //     Number(discountPercent) +
              //     Number(selectedDis2?.discountPercent);
              //   //console.log("987", newD)
              //   let finD = newD / 2;
              //   //console.log("setfromdebounceR988", finD)
              //   // setDiscountPercent(finD);
              // } else {
              //   // setDiscountPercent(selectedDis2?.discountPercent);
              // }
            } else {
            }
            // //console.log("that happening")

            // let selectedDis2 = dissArray
            //   .reverse()
            //   .find((item) => item.product.color === obj.color);
            // setNameR(selectedDis2.product.productName)
            // setDiscountPercent(selectedDis2.discountPercent);

            // setDiscountAmount(selectedDis2.discountedPrice);
          }
          //// //console.log(selectedDis, "dis");
        }
      } else {
        if (obj.orderDetail) {
          //console.log(obj, "this my product");
          //console.log("856");

          // setQuantity(obj.quantity);
          let productCode = "";
          if (obj.orderType === "Fitting") {
            // if (obj.orderDetail.fitting) {
            //   // setFitting(obj.orderDetail.fitting);
            //   let fitting = _.find(fittings, {
            //     fittingType: obj.orderDetail.fitting,
            //   });
            //   // setFittingAmount(fitting.amount);
            // }
            setLRate(obj.orderDetail.lRate);
            productCode =
              obj.orderDetail.lSph +
              "/" +
              obj.orderDetail.lCyl +
              "/" +
              obj.orderDetail.lAxis +
              "/" +
              obj.orderDetail.lAddition;
            console.log("864orderDetailcomp");

            // setNameL(obj.orderDetail.productName + "-" + productCode);
          } else {
            setLRate(obj.rate);
            productCode =
              obj.orderDetail.lSph +
              "/" +
              obj.orderDetail.lCyl +
              "/" +
              obj.orderDetail.lAxis +
              "/" +
              obj.orderDetail.lAddition;
            if (obj.orderDetail.product) {
              console.log("396comp");
              // setNameL(
              //   obj.orderDetail.product.productName + "-" + productCode
              // );
            }
          }
          // setOrderRef(obj.code);
          // setLProductCode(productCode);
        }
      }
    }
  }, [readyMasters, party, fittings, orders, getCachedCodes, userInfo.entity]);

  const afterSelectR = useCallback((codeR) => {
    let obj;

    // First check if it's an order code
    if (orders && orders.length > 0) {
      obj = orders.find((o) => o.code === codeR);
    }

    // If not found in orders, check readyMasters
    if (!obj && readyMasters && readyMasters.length > 0) {
      obj = _.find(readyMasters, { productCode: codeR });
    }

    // If still not found, try to get from cache using the code prefix
    if (!obj && codeR && codeR.length >= 5) {
      // Try to find in cache by checking prefixes
      for (let i = codeR.length; i >= 5; i--) {
        const prefix = codeR.substring(0, i);
        const cachedData = getCachedCodes(userInfo.entity, prefix, "R");
        if (cachedData && cachedData.length > 0) {
          obj = cachedData.find((item) => item.productCode === codeR);
          if (obj) {
            // Update readyMasters with cached data so it's available for future use
            setReadyMasters(cachedData);
            break;
          }
        }
      }
    }

    if (obj) {
      console.log(obj, "this my product");
      if (obj.productName) {
        // Ready master product - set all fields
        setRRate(obj.rate);
        setDia(obj.dia);
        setRSph(obj.sph);
        setRCyl(obj.cyl);
        setRAxis(obj.axis);
        setRAddition(obj.addition);
        setProductNameR(obj.productName);
        setProduct(obj);

        let dissArray = party?.discounts;
        if (dissArray && dissArray.length > 0 && obj) {
          console.log(dissArray, "diss");
          console.log(obj, "dissObj");
          let selectedDis = dissArray
            .reverse()
            .find((item) => item.type === "Range");
          console.log("this happening", selectedDis);
          if (selectedDis) {
            let fR = selectedDis?.product?.codeRanges?.find(
              (item) => item == codeR
            );
            console.log(fR, "fR");
            if (fR != undefined) {
              console.log(
                "comp316",
                selectedDis.product.productName,
                selectedDis.discountedPrice,
                selectedDis.discountPercent
              );
              // setNameR(selectedDis.product.productName)
              setRRate(selectedDis.discountedPrice);
              // setDiscountPercent(selectedDis.discountPercent);
              console.log("321");
            }
          } else {
            console.log("no range here");
            let selectedDis2 = dissArray
              .reverse()
              .find(
                (item) =>
                  (!item.type || item.type === "Color") &&
                  item.product?.color &&
                  obj.color &&
                  String(item.product.color).trim().toLowerCase() ===
                  String(obj.color).trim().toLowerCase()
              );
            console.log("forReal>>>>editse", selectedDis2, codeR, dissArray);
            console.log("comp330", selectedDis2);
            if (selectedDis2) {
              // setNameR(selectedDis2?.product?.productName)
              setRRate(selectedDis2?.discountedPrice);
              // setDiscountPercent(selectedDis2.discountPercent)
              // setDiscountPercent(selectedDis2?.discountPercent);
              // setDiscountAmount(selectedDis2.discountedPrice);
              // if (discountPercent > 0) {
              //   let newD =
              //     Number(discountPercent) +
              //     Number(selectedDis2?.discountPercent);
              //   //console.log("987", newD)
              //   let finD = newD / 2;
              //   //console.log("setfromdebounceR988", finD)
              //   // setDiscountPercent(finD);
              // } else {
              //   // setDiscountPercent(selectedDis2?.discountPercent);
              // }
            } else {
            }
            // //console.log("that happening")

            // let selectedDis2 = dissArray
            //   .reverse()
            //   .find((item) => item.product.color === obj.color);
            // setNameR(selectedDis2.product.productName)
            // setDiscountPercent(selectedDis2.discountPercent);

            // setDiscountAmount(selectedDis2.discountedPrice);
          }
          //// //console.log(selectedDis, "dis");
        }
      } else {
        if (obj.orderDetail) {
          //console.log(obj, "this my product");
          //console.log("856");

          // setQuantity(obj.quantity);
          let productCode = "";
          if (obj.orderType === "Fitting") {
            // if (obj.orderDetail.fitting) {
            //   // setFitting(obj.orderDetail.fitting);
            //   let fitting = _.find(fittingMasters, {
            //     fittingType: obj.orderDetail.fitting,
            //   });
            //   // setFittingAmount(fitting.amount);
            // }
            setRRate(obj.orderDetail.rRate);
            productCode =
              obj.orderDetail.rSph +
              "/" +
              obj.orderDetail.rCyl +
              "/" +
              obj.orderDetail.rAxis +
              "/" +
              obj.orderDetail.rAddition;
            console.log("864orderDetailcomp");

            // setNameR(obj.orderDetail.productName + "-" + productCode);
          } else {
            setRRate(obj.rate);
            productCode =
              obj.orderDetail.rSph +
              "/" +
              obj.orderDetail.rCyl +
              "/" +
              obj.orderDetail.rAxis +
              "/" +
              obj.orderDetail.rAddition;
            if (obj.orderDetail.product) {
              console.log("396comp");
              // setNameR(
              //   obj.orderDetail.product.productName + "-" + productCode
              // );
            }
          }
          // setOrderRef(obj.code);
          // setRProductCode(productCode);
        }
      }
    }
  }, [readyMasters, party, fittings, orders, getCachedCodes, userInfo.entity]);

  function _setCategoryImage(files) {
    setCategoryImage(files);
  }

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={close}
      aria-labelledby="responsive-dialog-title"
    >
      <GridContainer>
        <GridItem xs={12} sm={12}>
          <Card>
            <CardHeader color="primary">
              <Box
                display={"flex"}
                alignItems={"center"}
              // justifyContent={"space-between"}
              >
                <h4 className={classes.cardTitleWhite}>
                  Add Ready / Fitting Order
                </h4>
                <Box display="flex" alignItems="center">
                  {orders?.length > 0 && (
                    <Button
                      color="transparent"
                      onClick={() => setOpenOrdersDialog(true)}
                      style={{ color: "white" }}
                    >
                      View Orders
                    </Button>
                  )}
                  <Button color={"transparent"} onClick={() => close()}>
                    Close
                  </Button>
                  <Button color={"transparent"} onClick={() => _onSave()} disabled={isSavingOrders}>
                    {isSavingOrders ? "Saving…" : "Save"}
                  </Button>
                </Box>
              </Box>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12}>
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    <FilePicker
                      files={categoryImage}
                      buttonLabel={"Upload Fitting Order Image*"}
                      id={"Fitting Photo"}
                      maxFiles={1}
                      setNewFiles={_setCategoryImage}
                      filetype={".png,.jpg,.jpeg"}
                    />
                  </div>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}>
                  <Autocomplete
                    className={classes.formControl}
                    options={accounts}
                    value={party}
                    onChange={(event, newValue) => {
                      setParty(newValue);
                    }}
                    getOptionLabel={(option) => option.name}
                    id="party"
                    renderInput={(params) => (
                      <TextField {...params} label="Party*" />
                    )}
                  />
                </GridItem>
                <GridItem xs={3} sm={3} md={3}>
                  <Autocomplete
                    filterOptions={filterOptions}
                    loading={loadingCodesR}
                    className={classes.formControl}
                    options={codesR.slice(0, 200)}
                    fullWidth
                    value={rLens}
                    onChange={(event, value) => {
                      setRLens(value);
                      afterSelectR(value);
                    }}
                    onInputChange={(e, value) => {
                      debouncedEffect(value);
                    }}
                    getOptionLabel={(option) => option}
                    style={{ marginTop: 26 }}
                    id="rLens"
                    renderInput={(params) => (
                      <TextField {...params} label="R Lens" />
                    )}
                  />
                </GridItem>
                <GridItem xs={3} sm={3} md={3}>
                  <Autocomplete
                    filterOptions={filterOptions}
                    loading={loadingCodesL}
                    className={classes.formControl}
                    options={codesL.slice(0, 200)}
                    fullWidth
                    value={lLens}
                    onChange={(event, value) => {
                      setLLens(value);
                      afterSelectL(value);
                    }}
                    onInputChange={(e, value) => {
                      debouncedEffectL(value);
                    }}
                    getOptionLabel={(option) => option}
                    style={{ marginTop: 26 }}
                    id="lLens"
                    renderInput={(params) => (
                      <TextField {...params} label="L Lens" />
                    )}
                  />
                </GridItem>
                <GridItem xs={3} sm={3} md={3}>
                  <CustomInput
                    labelText="Fitter"
                    id="fitter"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: fitter,
                      onChange: (event) => setFitter(event.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={3} sm={3} md={3}>
                  <Autocomplete
                    className={classes.formControl}
                    options={fittings}
                    fullWidth
                    value={fitting}
                    onChange={(event, value) => setFitting(value)}
                    getOptionLabel={(option) => option.fittingType}
                    style={{ marginTop: 26 }}
                    id="fitting"
                    renderInput={(params) => (
                      <TextField {...params} label="Fitting" />
                    )}
                  />
                </GridItem>
                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="Total Rate*"
                    id="amount"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      type: "number",
                      value: amount,
                      onChange: (event) => setAmount(event.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="Quantity*"
                    id="quantity"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: quantity,
                      type: "number",
                      onChange: (event) => setQuantity(event.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="C/G"
                    id="cg"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: cg,
                      onChange: (event) => setCg(event.target.value),
                    }}
                  />
                </GridItem>
                <MuiPickersUtilsProvider utils={DateUtils}>
                  <GridItem xs={3} sm={3} md={3} style={{ marginTop: 26 }}>
                    <DatePicker
                      label="Given"
                      fullWidth
                      format={"DD-MM-YYYY"}
                      minDate={new Date()}
                      value={given}
                      onChange={(date) => setGiven(date)}
                      animateYearScrolling
                    />
                  </GridItem>
                  <GridItem xs={3} sm={3} md={3} style={{ marginTop: 26 }}>
                    <DatePicker
                      label="Received"
                      fullWidth
                      minDate={given}
                      format={"DD-MM-YYYY"}
                      value={received}
                      onChange={(date) => setReceived(date)}
                      animateYearScrolling
                    />
                  </GridItem>
                </MuiPickersUtilsProvider>

                <GridItem xs={3} sm={3} md={3}>
                  <CustomInput
                    labelText="Party Ref"
                    id="partyRef"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: partyRef,
                      onChange: (event) => setPartyRef(event.target.value),
                    }}
                  />
                </GridItem>

                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="R Rate"
                    id="rRate"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: rRate,
                      onChange: (event) => setRRate(event.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="L Rate"
                    id="lRate"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: lRate,
                      onChange: (event) => setLRate(event.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={3} sm={3} md={3}>
                  <CustomInput
                    labelText="Product Name R"
                    id="productNameR"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: productNameR,
                      onChange: (event) => setProductNameR(event.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={3} sm={3} md={3}>
                  <CustomInput
                    labelText="Product Name L"
                    id="productNameL"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: productNameL,
                      onChange: (event) => setProductNameL(event.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={3} sm={3} md={3}>
                  <CustomInput
                    labelText="Quote"
                    id="quote"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: quote,
                      onChange: (event) => setQuote(event.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="Dia"
                    id="dia"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: dia,
                      onChange: (event) => setDia(event.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={3} sm={3} md={3}>
                  <CustomInput
                    labelText="Order Notes"
                    id="orderNotes"
                    multiline={true}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: orderNotes,
                      onChange: (event) => setOrderNotes(event.target.value),
                    }}
                  />
                </GridItem>
                {/* <GridItem xs={2} sm={2} md={2}></GridItem>
                <GridItem xs={2} sm={2} md={2}></GridItem> */}
                <GridItem xs={2} sm={2} md={2}></GridItem>
                <GridItem xs={2} sm={2} md={2}></GridItem>
                <GridItem xs={2} sm={2} md={2}></GridItem>
                <GridItem xs={2} sm={2} md={2}>
                  <p>Sph</p>
                </GridItem>
                <GridItem xs={2} sm={2} md={2}>
                  <p>Cyl</p>
                </GridItem>
                <GridItem xs={2} sm={2} md={2}>
                  <p>Axis</p>
                </GridItem>
                <GridItem xs={2} sm={2} md={2}>
                  <p>Addn</p>
                </GridItem>
                <GridItem xs={2} sm={2} md={2}></GridItem>
                <GridItem xs={2} sm={2} md={2}>
                  <p>Right</p>
                </GridItem>
                <GridItem xs={2} sm={2} md={2}>
                  <CustomInput
                    labelText=""
                    id="rSph"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: rSph,
                      onChange: (event) => setRSph(event.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={2} sm={2} md={2}>
                  <CustomInput
                    labelText=""
                    id="rCyl"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: rCyl,
                      onChange: (event) => setRCyl(event.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={2} sm={2} md={2}>
                  <CustomInput
                    labelText=""
                    id="rAxis"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: rAxis,
                      onChange: (event) => setRAxis(event.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={2} sm={2} md={2}>
                  <CustomInput
                    labelText=""
                    id="rAddition"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: rAddition,
                      onChange: (event) => setRAddition(event.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={2} sm={2} md={2}></GridItem>
                <GridItem xs={2} sm={2} md={2}>
                  <p>Left</p>
                </GridItem>
                <GridItem xs={2} sm={2} md={2}>
                  <CustomInput
                    labelText=""
                    id="lSph"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: lSph,
                      onChange: (event) => setLSph(event.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={2} sm={2} md={2}>
                  <CustomInput
                    labelText=""
                    id="lCyl"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: lCyl,
                      onChange: (event) => setLCyl(event.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={2} sm={2} md={2}>
                  <CustomInput
                    labelText=""
                    id="lAxis"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: lAxis,
                      onChange: (event) => setLAxis(event.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={2} sm={2} md={2}>
                  <CustomInput
                    labelText=""
                    id="lAddition"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: lAddition,
                      onChange: (event) => setLAddition(event.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={1}>
                  <Box justifyContent={"center"} marginTop={4}>
                    <Fab
                      size={"small"}
                      color="primary"
                      aria-label="add"
                      onClick={() => {
                        if (
                          party === null ||
                          quantity === "" ||
                          amount === ""
                        ) {
                          toast.error("Please fill all the required fields", {
                            position: "top-center",
                            autoClose: 1500,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                          });
                          return;
                        }
                        let orderAmount = Number(amount) * Number(quantity);
                        const imagePath = categoryImage.name ? categoryImage.name : "";
                        let object = {
                          orderType: "Fitting",
                          orderNotes: orderNotes,
                          party: {
                            accountCode: party.accountCode,
                            accountId: party._id,
                            accountName: party.name,
                            accountAddress: party.address,
                            accountGst: party.gst,
                          },
                          orderDetail: {
                            rLens,
                            lLens,
                            fitter,
                            fitting: fitting ? fitting.fittingType : "",
                            cg,
                            given,
                            received,
                            amount,
                            quantity,
                            partyRef,
                            rRate,
                            lRate,
                            product,
                            productNameR,
                            productNameL,
                            quote,
                            dia,
                            rSph,
                            rCyl,
                            rAxis,
                            rAddition,
                            lSph,
                            lCyl,
                            lAxis,
                            lAddition,
                            orderNotes, // <-- add note to orderDetail
                          },
                          orderAmount,
                          price: amount,
                          quantity,
                          createdBy: userInfo._id,
                          createdByName: userInfo.name,
                          orderAdminStatus: "Pending",
                          imageName: imagePath,
                        };

                        let copy = _.clone(items);
                        copy.push(object);
                        setItems(copy);
                        setCategoryImage([]);
                        setLRate("");
                        setDia("");
                        setLSph("");
                        setLCyl("");
                        setLAxis("");
                        setLAddition("");
                        setProductNameR("");
                        setProductNameL("");
                        setProduct("");
                        setRRate("");
                        setRSph("");
                        setRCyl("");
                        setRAxis("");
                        setRAddition("");

                        setRLens("");
                        setLLens("");
                        setFitter("");
                        setFitting("");
                        setGiven(new Date());
                        setReceived(new Date());
                        setCg("");
                        setAmount("");
                        setQuantity("");
                        setPartyRef("");

                        setQuote("");
                        setOrderNotes("");
                      }}
                    >
                      <AddIcon />
                    </Fab>
                  </Box>
                </GridItem>

                {_.isEmpty(items) ? null : (
                  <GridItem xs={12}>
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow>
                          {columns.map((column) => (
                            <TableCell
                              key={column.id}
                              align={"center"}
                              style={{ minWidth: column.minWidth }}
                            >
                              {column.label}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {items.map((row, index) => {
                          return (
                            <TableRow
                              hover
                              role="checkbox"
                              tabIndex={-1}
                              key={row.code}
                            >
                              {columns.map((column) => {
                                let value = row.orderDetail[column.id];
                                if (column.id === "product") {
                                  value = row.orderDetail?.product?.productName
                                    ? row.orderDetail.product.productName
                                    : "";
                                }
                                if (column.id === "party") {
                                  value = row.party.accountName;
                                }
                                if (column.id === "action") {
                                  return (
                                    <TableCell align={"center"}>
                                      <Box
                                        display={"flex"}
                                        justifyContent={"center"}
                                      >
                                        <IconButton
                                          aria-label="delete"
                                          onClick={() => {
                                            let copy = _.clone(items);
                                            copy.splice(index, 1);
                                            setItems(copy);
                                          }}
                                        >
                                          <DeleteIcon />
                                        </IconButton>
                                      </Box>
                                    </TableCell>
                                  );
                                }
                                return (
                                  <TableCell key={column.id} align={"center"}>
                                    {value}
                                  </TableCell>
                                );
                              })}
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </GridItem>
                )}
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      {openOrdersDialog && (
        <ChallanOrdersDialog
          open={openOrdersDialog}
          onClose={() => setOpenOrdersDialog(false)}
          data={orders}
          OnR={setFormFromOrder}
          OnL={setFormFromOrder}
        />
      )}
    </Dialog>
  );
}
